import { getBestCourtAssignmentsTwoStage } from '@badminton/matchmaking-core';

export { getBestCourtAssignmentsTwoStage };
export { getBestCourtAssignmentsTwoStage as getBestCourtAssignments_TwoStage };

export function updatePlayerInteractions(team1, team2, sessionState) {
  // Ensure playerInteractions is a plain object (not a Map)
  // This is consistent with how it's stored in the database and read by scoreEngine
  if (!sessionState.playerInteractions) {
    sessionState.playerInteractions = {};
  }
  
  // Convert Map to object if it's a Map (for backward compatibility)
  if (sessionState.playerInteractions instanceof Map) {
    sessionState.playerInteractions = Object.fromEntries(sessionState.playerInteractions);
  }

  const allPlayers = [...team1, ...team2];
  const team1Ids = new Set(team1.map(p => p.id));
  const team2Ids = new Set(team2.map(p => p.id));

  for (let i = 0; i < allPlayers.length; i++) {
    for (let j = i + 1; j < allPlayers.length; j++) {
      const player1Id = allPlayers[i].id;
      const player2Id = allPlayers[j].id;
      const key = [player1Id, player2Id].sort().join('-');

      // Use plain object access instead of Map methods
      const currentCount = sessionState.playerInteractions[key] || 0;
      sessionState.playerInteractions[key] = currentCount + 1;

      const areOnSameTeam =
        (team1Ids.has(player1Id) && team1Ids.has(player2Id)) ||
        (team2Ids.has(player1Id) && team2Ids.has(player2Id));

      if (areOnSameTeam) {
        const sameTeamKey = `${key}_sameTeam`;
        const currentSameTeamCount = sessionState.playerInteractions[sameTeamKey] || 0;
        sessionState.playerInteractions[sameTeamKey] = currentSameTeamCount + 1;
      }
    }
  }
}
